import styled from 'styled-components';

export const InfoText = styled.p<{ size?: string; color?: string }>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.body.fontFamily};
  color: ${(props) =>
    props.color ?? props.theme.atlas.semantic.color.type.disabled};
  font-size: ${(props) => {
    switch (props.size) {
      case 'small':
        return '12px';
      case 'regular':
        return '15px';
      case 'large':
        return '20px';
      default:
        return '15px';
    }
  }};
`;
